import { trans } from '../localization/helpers';
import { AlertService } from '../alerts/services/alert.service';
import { ALERT_MESSAGES } from '../alerts/alert-messages';
import { Injector } from '@angular/core';
import { ModalRef } from './classes/modal-ref';
import { Buttons } from './classes/buttons';
import { MODAL_ACTION } from './modal-action';

export function addFormModalDeleteButtonTo(injector: Injector, modal: ModalRef) {
    const buttons: Buttons = modal.instance.modal.get('buttons');

    buttons.after('close', 'delete', {
        text: 'Delete',
        classes: '',
        callback: () => {
            const modalRef = modal.instance.modal;

            modal.instance.loader.start();

            const alerts = injector.get(AlertService);

            const prompt = alerts.open({
                title: trans(ALERT_MESSAGES.ARE_YOU_SURE),
            });

            prompt.result.then(() => {
                modalRef.close({
                    'action': MODAL_ACTION.DELETE,
                });
            }, () => {
                modal.instance.loader.stop();
            });
        }
    });
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/add-form-modal-delete-button-to.ts